import { ACCEPTED_FORMAT_LABELS } from '@/constants/upload';
import { env } from '@/config/env';
import { useFileDropzone } from '@/hooks/useFileDropzone';

interface UploadDropzoneProps {
  onFileAccepted: (file: File) => void;
  disabled?: boolean;
}

// const QUICK_SOURCES = [
//   { key: 'camera', icon: 'bi-camera', label: 'Camera' },
//   { key: 'drive', icon: 'bi-cloud-plus', label: 'Drive' },
//   { key: 'chat', icon: 'bi-chat-square-text', label: 'Chat File' },
// ] as const;

export function UploadDropzone({ onFileAccepted, disabled }: UploadDropzoneProps) {
  const { inputRef, acceptAttr, isDragging, openFilePicker, handleInputChange, handleDragOver, handleDragLeave, handleDrop } =
    useFileDropzone({ onFileAccepted });

  return (
    <div
      className={[
        'upload-dropzone rounded-4 p-4 p-lg-5 d-flex flex-column align-items-center text-center',
        isDragging ? 'is-dragging' : '',
      ].join(' ')}
      onClick={disabled ? undefined : openFilePicker}
      onDragOver={disabled ? undefined : handleDragOver}
      onDragLeave={disabled ? undefined : handleDragLeave}
      onDrop={disabled ? undefined : handleDrop}
      role="button"
      tabIndex={0}
      aria-disabled={disabled}
    >
      <input
        ref={inputRef}
        type="file"
        accept={acceptAttr}
        className="d-none"
        onChange={handleInputChange}
        disabled={disabled}
      />

      <div
        className="rounded-circle bg-surface-highest d-flex align-items-center justify-content-center mb-3 text-primary"
        style={{ width: 72, height: 72 }}
      >
        <i className="bi bi-cloud-arrow-up" style={{ fontSize: 32 }} />
      </div>

      <h2 className="text-headline-sm text-on-surface mb-1">Choose file to print</h2>
      <p className="text-body-sm text-on-surface-variant mb-3" style={{ maxWidth: 320 }}>
        Tap or drag anywhere to browse.
      </p>

      <button
        type="button"
        className="btn btn-primary tap-target active-press w-100 d-flex align-items-center justify-content-center gap-2 text-label-lg"
        style={{ maxWidth: 360, height: 50 }}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          openFilePicker();
        }}
      >
        <i className="bi bi-phone" />
        <span>Choose from device</span>
      </button>

      {/* <div className="row row-cols-3 g-2 w-100 mt-3" style={{ maxWidth: 360 }}>
        {QUICK_SOURCES.map((source) => (
          <div className="col" key={source.key}>
            <button
              type="button"
              className="btn bg-surface-lowest shadow-kiosk-sm w-100 h-100 d-flex flex-column flex-sm-row align-items-center justify-content-center gap-1 active-press border-0 text-label-sm text-on-surface py-2"
              disabled={disabled}
              onClick={(e) => e.stopPropagation()}
            >
              <i className={`bi ${source.icon} text-primary`} />
              <span className="text-truncate">{source.label}</span>
            </button>
          </div>
        ))}
      </div> */}

      <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 mt-3 pt-1">
        {ACCEPTED_FORMAT_LABELS.map((label) => (
          <span key={label} className="badge bg-surface-highest text-on-surface-variant text-label-sm fw-medium">
            {label}
          </span>
        ))}
        <span className="text-body-sm text-on-surface-variant ms-1">Up to {env.maxUploadMb}MB</span>
      </div>
    </div>
  );
}
